<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Timbrar depósito
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Timbrar depósito</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <form [formGroup]='formHeader' novalidate>
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde">
            </mdb-date-picker>
            <div *ngIf="
                        formHeader.get('fechaDesde').invalid &&
                        (formHeader.get('fechaDesde').dirty ||
                        formHeader.get('fechaDesde').touched)
                        ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                Ingrese fecha desde
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta">
            </mdb-date-picker>
            <div *ngIf="
                        formHeader.get('fechaHasta').invalid &&
                        (formHeader.get('fechaHasta').dirty ||
                        formHeader.get('fechaHasta').touched)
                        ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">
                Ingrese fecha hasta
              </mdb-error>
            </div>
          </div>
        </div>
        <div style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="" #rutcliente
              formControlName="rutCliente" formatRut />
            <label for="rutcliente">RUT</label>
            <div *ngIf="
                        formHeader.get('rutCliente').invalid &&
                        (formHeader.get('rutCliente').dirty ||
                        formHeader.get('rutCliente').touched)
                    ">
              <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">
                Ingrese rut cliente
              </mdb-error>
            </div>
          </div>
        </div>
        <div style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarClientes()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
        </div>
        <div class="col" style="width: 350px; align-self: center;">
          <span class="text-info" style="display: contents; font-size: 12px; ">{{ clienteSeleccionado?.razon_social }}</span>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <input value="" type="text" id="nroCheque" class="form-control" placeholder="XXXXXXXXXX" #nroCheque
              formControlName="nroDoc" onlyNumbers />
            <label for="nroCheque">Nro. de Cheque</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <input value="" type="text" id="nroDeposito" class="form-control" placeholder="XXXXXXXXXX" #nroCheque
              formControlName="nroDeposito" onlyNumbers />
            <label for="nroDeposito">Nro. de Deposito</label>
          </div>
        </div>
      </div>
      <div class="row filtros-body">
        <div class="col d-flex">
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline">
            <mdb-checkbox formControlName="porTimbrar">Por Timbrar</mdb-checkbox>
          </div>
          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <mdb-checkbox formControlName="timbrados">Timbrados</mdb-checkbox>
          </div>
            <div class="md-form" style="padding: 3px; margin-left: 10px;">
              <input value="" type="text" id="filtroMonto" class="form-control" placeholder="XXXXXXXXXX" #nroCheque
                formControlName="filtroMonto" onlyNumbers style="width: 200px; font-size: 14px;" />
              <label for="filtroMonto">Buscar por Monto</label>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div class="resultados pl-2"></div>
    <div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarData()">Limpiar</button>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)"><mdb-icon
          fasicon="search"></mdb-icon>Buscar</button>
    </div>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

    <div class="table-responsive" *ngIf="listaDepositos">

      <app-no-data-alert *ngIf="listaDepositos?.length === 0">
      </app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaDepositos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col"><mdb-checkbox (change)="checkAllChange($event)" [(ngModel)]="checkAll"></mdb-checkbox></th>
            <th scope="col">Banco destino</th>
            <th scope="col">Cuenta bancaria</th>
            <th scope="col">N° Deposito</th>
            <th scope="col">Fecha</th>
            <th scope="col">RUT depositante</th>
            <th scope="col">Nombre</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let deposito of listaDepositos"
            [ngClass]="{estadoTimbrar1:deposito.estado_timbrado == 'Depositado', estadoTimbrar2: deposito.estado_timbrado == 'Redepositado', estadoTimbrar3: deposito.estado_timbrado == 'Protestado', estadoTimbrar4: deposito.estado_timbrado == 'Cambio de Fecha', estadoTimbrar5: deposito.estado_timbrado == 'Reverso'}">
            <td>
              <div class="row" style="max-width: 85px;">
                <div class="col" style="max-width: 40px;">
                  <mdb-checkbox [checked]="deposito.additionalData.seleccion" (change)='checkDetalle(deposito)'
                    *ngIf="deposito.activo">
                  </mdb-checkbox>
                </div>
                <div class="col p-0" style="max-width: 40px;">
                  <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                    (click)="verDetalle(deposito)" mdbTooltip="Ver" placement="right">
                    <mdb-icon fas icon="eye"></mdb-icon>
                  </button>
                </div>
              </div>
            </td>
            <td class="black-text">{{deposito.banco_nombre_destino}}</td>
            <td class="black-text">{{deposito.numero_cuenta}}</td>
            <td class="black-text">{{deposito.numero_deposito}}</td>
            <td class="black-text">{{deposito.fecha_deposito | fecha }}</td>
            <td class="black-text">{{deposito.additionalData.depositanteRutFormato | rut}}</td>
            <td class="black-text">{{deposito.depositante_nombre}}</td>
            <td class="text-right">{{deposito.monto | numerico}}</td>
            <td class="black-text"><strong>{{deposito.estado_timbrado}}</strong></td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaDepositos?.length > 0"></app-pagination>
      </table>
    </div>


  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaDepositos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn size="sm" class="btn btn-sm" type="button" color="success" mdbWavesEffect (click)="timbrar()">
      TIMBRAR
    </button>
  </div>

</div>

<!-- MODAL verDeposito -->
<app-modal-deposito-detalle></app-modal-deposito-detalle>
<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT_BLO_DESB" showInfoClienteInactivoBloqueado="true"
  (onSelectSingle)="onClienteSeleccionado($event)" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>
